import React from "react";
import { motion } from "framer-motion";
import { Check } from "@phosphor-icons/react";

const COLORS = ["var(--cf-accent)", "#ffffff", "#facc15", "#38bdf8"];
const PIECES = Array.from({ length: 42 }, (_, i) => ({
  i,
  x: (Math.random() - 0.5) * 560,
  y: -(140 + Math.random() * 260),
  r: Math.random() * 720 - 360,
  d: Math.random() * 0.25,
  w: 6 + (i % 3) * 3,
  c: COLORS[i % COLORS.length],
}));

export const ConfettiBurst = () => (
  <div className="pointer-events-none absolute left-1/2 top-1/3" aria-hidden="true" data-testid="case-confetti">
    {PIECES.map((p) => (
      <motion.span
        key={p.i}
        className="absolute block rounded-sm"
        style={{ width: p.w, height: p.w * 0.5, background: p.c }}
        initial={{ x: 0, y: 0, opacity: 1, rotate: 0 }}
        animate={{ x: p.x, y: [0, p.y, p.y + 460], opacity: [1, 1, 0], rotate: p.r }}
        transition={{ duration: 1.8, delay: p.d, ease: "easeOut" }}
      />
    ))}
  </div>
);

export const CheckBadge = ({ size = 80 }) => (
  <motion.div
    initial={{ scale: 0, rotate: -30 }}
    animate={{ scale: 1, rotate: 0 }}
    transition={{ type: "spring", stiffness: 260, damping: 14, delay: 0.1 }}
    className="cf-check mx-auto grid place-items-center rounded-full bg-[var(--cf-accent)] text-white"
    style={{ width: size, height: size }}
  >
    <Check size={size / 2} weight="bold" />
  </motion.div>
);

export const Celebration = ({ firmName, previewOnly }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    className="absolute inset-0 z-20 grid place-items-center overflow-hidden rounded-2xl bg-[#0a1929]"
    data-testid="case-quiz-celebration-banner"
  >
    <ConfettiBurst />
    <div className="relative px-6 text-center">
      <CheckBadge />
      <h3 className="lp-serif mt-6 text-2xl font-bold text-white sm:text-3xl">Your case is in!</h3>
      <p className="mt-2 text-sm text-slate-300" data-testid="case-quiz-celebration-text">
        {previewOnly
          ? "Preview only — no lead was sent."
          : (firmName ? `Sending it to ${firmName} now…` : "Matching you with an attorney now…")}
      </p>
    </div>
  </motion.div>
);
